import React from 'react'

function Spinner() {
    return (
        <div data-testid="loading-spinner" className="inline-flex items-center gap-2 ml-3">
            <div
                style={{
                    width: 18,
                    height: 18,
                    border: '2px solid #E4E4E7',
                    borderTop: '2px solid #002FA7',
                    borderRadius: 0,
                    animation: 'spin 0.7s linear infinite'
                }}
            />
        </div>
    )
}

export default Spinner
